import React, { useRef } from 'react';
import { SERVICES } from '../data/mock';
import { Heart, ChevronLeft, ChevronRight } from 'lucide-react';

const ServicesSection = () => {
  const trackRef = useRef(null);
  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-24 bg-slate-50">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">A Summary of what we offer</p>
          <h2 className="heading-display text-4xl md:text-5xl font-bold text-slate-900">Our Services</h2>
          <div className="mx-auto mt-4 flex items-center justify-center gap-1">
            <span className="w-8 h-0.5 bg-[#F97559]" />
            <span className="w-2 h-2 rounded-full bg-[#F97559]" />
            <span className="w-8 h-0.5 bg-[#F97559]" />
          </div>
        </div>

        <div className="relative">
          <div ref={trackRef} className="flex gap-7 overflow-x-auto snap-x scroll-smooth pb-4 -mx-2 px-2" style={{ scrollbarWidth: 'none' }}>
            {SERVICES.map((s, i) => (
              <article key={i} className="min-w-[280px] sm:min-w-[320px] md:min-w-[360px] flex-1 bg-white rounded-sm overflow-hidden shadow-sm card-lift snap-start">
                <div className="relative h-56 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" />
                  <button aria-label="Like" className="absolute top-3 left-3 w-9 h-9 bg-white rounded-full grid place-items-center text-slate-700 hover:text-[#F97559] transition-colors shadow">
                    <Heart size={16} />
                  </button>
                </div>
                <div className="p-7">
                  <h3 className="heading-display text-xl font-bold text-slate-900 leading-snug hover:text-[#F97559] cursor-pointer transition-colors">{s.title}</h3>
                  <p className="mt-4 text-slate-600 text-[14px] leading-7">{s.desc}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="flex justify-center gap-3 mt-8">
            <button onClick={() => scrollBy(-1)} className="w-11 h-11 rounded-full border border-slate-300 hover:bg-[#F97559] hover:text-white hover:border-[#F97559] grid place-items-center text-slate-600 transition-colors" aria-label="Prev"><ChevronLeft /></button>
            <button onClick={() => scrollBy(1)} className="w-11 h-11 rounded-full border border-slate-300 hover:bg-[#F97559] hover:text-white hover:border-[#F97559] grid place-items-center text-slate-600 transition-colors" aria-label="Next"><ChevronRight /></button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
